import React from "react";
// import SkillsList from "../elements/SkillsList";
// import Resume from "../../../resume.json";

function Certificate() {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="content_subtitle has-text-white">Certificates</div>
        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span>
                <img className="about_img" src="/images/AWS.png" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">AWS Certified Solutions Architect – Associate</div>
              <h4 className="content_content_uni has-text-white about_time">2021.06</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
        </div>
        <div className="columns about_container">
          <div className="column is-one-fifth about_sub_container"/>
          <div className="column is-1">
            <span className="larger"> 
                <img className="about_img" src="/images/AZ.png" alt=""></img>
            </span>
          </div>
          <div className="column is-6">
            <div className="has-text-left">
              <div className="content_title_uni has-text-white is-capitalized about_title">Microsoft Certified: Azure Fundamentals</div>
              <h4 className="content_content_uni has-text-white about_time">2021.05</h4>
            </div>
          </div>
          <div className="column is-1 about_sub_container"/>
          
        </div>

        {/* <div className="columns">
          <div className="column is-full">
              <div className="has-text-centered">
                <span className="icon has-text-link">
                  <i className="fas fa-3x fa-laptop-code"></i>
                </span>
                <h2 className="title is-5 has-text-white">Software Development</h2>
              </div>
              <SkillsList
                skills={Resume.skills
                  .filter(skill => skill.keywords.includes("Software Developer"))
                  .reduce((obj, item) => {
                    obj[item.name] = item.level;
                    return obj;
                  }, {})}
              />
            </div>
        </div> */}
      </div>
    </section>
  );
}

export default Certificate;
